import React from 'react'
import styles from './Player.module.css';

export default function BorderTimer({ timer }) {
    if (!timer) return null;

    return (
        <div className={styles.borderTimer}>
            <div 
                className={styles.timerProgress} 
                style={{ animationDuration: `${timer}s` }}
            />
        </div>
    )
}
